module.exports = __webpack_public_path__ + "img/jilu-img1.630ddbfd.png";